import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const ChangePasswordAdmin = ({ data }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const id = data.id

  const handleCurrentPasswordChange = (event) => {
    setCurrentPassword(event.target.value);
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };
  
  const handleChangePass = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_CHANGE_PASSWORD_ADMIN_SUPPLIER}`,
        {
          currentPassword,
          newPassword,
          id,
        }
      );

      Swal.fire({
        icon: "success",
        title: "Contraseña actualizada",
        text: "Tu contraseña ha sido actualizada correctamente." || res.data.message,
      });
      setNewPassword("")
      setCurrentPassword("")
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al intentar cambiar la contraseña. Por favor, inténtalo de nuevo más tarde.",
      });
    }
  };

  return (
    <div className="boxpassword">
        <div className="dosplayinputProvprofile">
          <div className="boxinputprovprofile">
            <label className="labelformprovprofile">Contraseña actual</label>
            <input
              className="inputupdateProvprofile"
              type="password"
              value={currentPassword}
              onChange={handleCurrentPasswordChange}
              required
            />
          </div>
          <div className="boxinputprovprofile">
            <label className="labelformprovprofile">Contraseña nueva</label>
            <input
              className="inputupdateProvprofile"
              type="password"
              value={newPassword}
              onChange={handleNewPasswordChange}
              required
            />
          </div>
        </div>
        <div className="boxprovbuttonprfile2">
          <button type="submit" className="buttonprovprofile" onClick={handleChangePass}>
            Cambiar Contraseña
          </button>
        </div>
    </div>
  );
};

export default ChangePasswordAdmin;